import { YEAR_GROUPS_RETRIEVED } from './year-groups-actions';

const initialState = [];

/**
 * Year Groups Reducer
 *
 * Consumes YEAR_GROUPS_RETRIEVED action
 *
 * @param {boolean} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {array} - school year groups with their teachers and classes
 */
export default function(state = initialState, action) {
    if (!action) return state;

    switch (action.type) {
        case YEAR_GROUPS_RETRIEVED:
            return action.payload;

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./components/report-filters/redux/year-groups/year-groups-reducer.js